import { type OfferTemplatePlanData } from '@on3/api/src';
import { useSubscribe } from '@on3/ui-lib/components/Subscription/Provider';
import { type JoinTemplateProps } from '@on3/ui-lib/components/Subscription/Templates/Join';
import { On3 } from '@on3/ui-lib/components/Svg';
import { TheAthletic as TheAthleticLogo } from '@on3/ui-lib/components/Svg/TheAthletic';

import styles from './TheAthleticJoin.module.scss';

interface TheAthleticJoinCardProps extends OfferTemplatePlanData {
  planKey?: string | null;
}

export const TheAthletic = ({
  handleJoin,
  props,
  template,
}: JoinTemplateProps) => {
  const { subscribeText } = useSubscribe();

  const TheAthleticJoinCard = ({
    planKey,
    title,
    line1,
    line2,
    line3,
    buttonText,
  }: TheAthleticJoinCardProps) => (
    <div className={styles.block} data-template-type="join" {...props}>
      {title && <span className={styles.highlight}>{title}</span>}
      <div className={styles.top}>
        {line1 && <h2>{line1}</h2>}
        {/* {price && <PriceDisplay price={price} />} */}
        {line2 && <span className={styles.lineTwo}>{line2}</span>}
      </div>
      <div className={styles.promo}>
        {line3 && (
          <figure className={styles.columnOne}>
            <img alt="On3 & The Athletic" src={line3} />
          </figure>
        )}
        <div className={styles.columnTwo}>
          {line1 === 'Annual' && (
            <>
              <figure className={styles.logos}>
                <div className={styles.on3}>
                  <On3 />
                </div>
                <div className={styles.theAthletic}>
                  <TheAthleticLogo />
                </div>
              </figure>
              <span className={styles.subheading}>
                Now included with Annual
              </span>
            </>
          )}
          {!!line1 && <p data-show="mobile">{line1}</p>}
          {!!line2 && <p data-show="desktop">{line2}</p>}
        </div>
      </div>
      <div className={styles.bottom}>
        <button onClick={() => handleJoin(planKey)} type="button">
          {buttonText || subscribeText}
        </button>
        <span className={styles.disclaimer}>Cancel anytime</span>
      </div>
    </div>
  );

  const cards = [
    {
      planKey: template.planKey1,
      planData: template.planData1,
    },
    {
      planKey: template.planKey2,
      planData: template.planData2,
    },
    {
      planKey: template.planKey3,
      planData: template.planData3,
    },
  ].filter((card) => !!card.planKey);

  return (
    <>
      {cards.map(({ planKey, planData }) => (
        <TheAthleticJoinCard
          buttonText={planData?.buttonText}
          key={planKey}
          line1={planData?.line1}
          line2={planData?.line2}
          line3={planData?.line3}
          planKey={planKey}
          title={planData?.title}
        />
      ))}
    </>
  );
};
